import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import ProfileSidebar from '../components/common/Avatar/ProfileSidebar';
import StudentDetails from '../components/Staffrecord/Editform/StudentDetails';
import CourseDetails from '../components/Staffrecord/Editform/CourseDetails';
import PerformanceSection from '../components/Staffrecord/Editform/PerformanceSection';
import ProjectsSection from '../components/Staffrecord/Editform/ProjectsSection';
import Qualification from '../components/Staffrecord/Editform/Qualification ';
import { useToast } from '../components/Admissionform/ToastManager';
import StaffDetails from '../components/Staffrecord/Editform/StaffDetails';
import PlacementTab from '../components/Staffrecord/Editform/PlacementTab';
import '../styles/StudentEntryForm.css';
import { useSoftMandatoryWarning } from "../components/Staffrecord/Editform/SoftMandatoryWarning";
import Swal from "sweetalert2";


const EditStudentRecord = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('studentDetails');
    const [formData, setFormData] = useState(null);
    const { showSuccess, showError, showWarning } = useToast();
    const { getSoftMandatoryWarnings } = useSoftMandatoryWarning(formData);
    const softPopupShownRef = useRef(false);
    const role = localStorage.getItem("role");
    const empId = localStorage.getItem("emp_id");

    const canUpdateVerification =
        role === "Super-Admin" ||
        empId === "5278";

    // Fetch student data
    const fetchStudentData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/student-rec/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data?.data) {
                const c = response.data.data.courseDetails;
                const r = response.data.data.studentRegistration;
                // Detect UG Degree Other
                const predefinedUGDegrees = ["B.Tech", "B.E", "B.Sc", "B.Com", "B.A"];
                const ugDegreeIsOther = c.ugDegree && !predefinedUGDegrees.includes(c.ugDegree);

                // Detect UG Department Other
                const predefinedUGDepartments = ["CSE", "IT", "Mechanical", "ECE", "EEE", "Civil"];
                const ugDepartmentIsOther = c.ugDepartment && !predefinedUGDepartments.includes(c.ugDepartment);

                // Detect PG Degree Other
                const predefinedPGDegrees = ["M.S", "M.Tech", "MBA"];
                const pgDegreeIsOther = c.pgDegree && !predefinedPGDegrees.includes(c.pgDegree);

                // Detect PG Department Other
                const predefinedPGDepartments = ["CSE", "IT", "Mechanical", "ECE", "EEE", "Civil"];
                const pgDepartmentIsOther = c.pgDepartment && !predefinedPGDepartments.includes(c.pgDepartment);


                const projects = [
                    { projectTitle: c.projectTitle1 || '', projectStatus: c.project1Status || '', projectScore: c.project1Score ?? 0, projectFeedback: c.project1Feedback || '' },
                    { projectTitle: c.projectTitle2 || '', projectStatus: c.project2Status || '', projectScore: c.project2Score ?? 0, projectFeedback: c.project2Feedback || '' },
                    { projectTitle: c.projectTitle3 || '', projectStatus: c.project3Status || '', projectScore: c.project3Score ?? 0, projectFeedback: c.project3Feedback || '' }
                ].filter(p => p.projectTitle || p.projectStatus || p.projectScore > 0 || p.projectFeedback);

                if (projects.length === 0) {
                    projects.push({ projectTitle: '', projectStatus: '', projectScore: 0 });
                }

                const mappedData = {
                    // 🔹 StudentRegistration Table
                    studentId: r.studentId,
                    studentName: c.studentName,
                    studentContactNumber: c.studentContactNumber,
                    ParentNo: r.ParentNo,
                    address: r.address,
                    dob: r.dob,
                    email: r.email_Id,
                    resumePath: r.resumePath,
                    offerLetterPath: r.offerLetterPath,
                    lastLogin: r.lastLogin,

                    // 🔹 CourseDetails Table
                    gender: c.gender,
                    location: c.desiredlocation ? c.desiredlocation.split(",") : [],
                    courseType: c.courseType,
                    courseName: c.courseName,
                    batch: c.batch,
                    learningMode: c.learningMode,
                    Department: c.Department,
                    skillsKnown: c.knownSkill ? c.knownSkill.split(",") : [],
                    branch: c.branch,
                    mentor: c.mentor,
                    mentorNumber: c.mentorNumber,
                    staffName1: c.staffName1,
                    staffName2: c.staffName2,
                    staffName3: c.staffName3,
                    placementneeded: c.placementneeded,
                    readyForPlacement: c.readyForPlacement,
                    placementStatus: c.placementStatus ?? "Awaiting for placement",
                    placementInterest: c.placementInterest,
                    staffRemarks: c.staffRemarks,
                    courseStartDate: c.courseStartDate,
                    courseEndDate: c.courseEndDate,
                    createdAt: c.createdAt,
                    readyForPlacementDate: c.readyForPlacementDate
                        ? new Date(c.readyForPlacementDate).toISOString().split("T")[0]
                        : "",

                    technicalScore: c.technicalScore,
                    communicationScore: c.communicationScore,
                    technologyRemarks: c.technologyRemarks,
                    communicationRemarks: c.communicationRemarks,
                    mockInterview: c.mockInterview,
                    mockRemarks: c.mockRemarks,
                    placementStatusChangedBy: c.placementStatusChangedBy,
                    placementStatusChangedAt: c.placementStatusChangedAt,

                    mockTest1Score: c.mockTest1Score,
                    mockTest2Score: c.mockTest2Score,
                    mockTest3Score: c.mockTest3Score,

                    studentProgressStatus: c.ProgressStatus,

                    // 🔹 Education fields
                    tenthInstitution: c.tenthInstitution,
                    tenthDepartment: c.tenthDepartment,
                    tenthDegree: c.tenthDegree,
                    tenthPassout: c.tenthPassout,
                    tenthPercentage: c.tenthPercentage,

                    twelfthInstitution: c.twelfthInstitution,
                    twelfthDepartment: c.twelfthDepartment,
                    twelfthDegree: c.twelfthDegree,
                    twelfthPassout: c.twelfthPassout,
                    twelfthPercentage: c.twelfthPercentage,

                    diplomaInstitution: c.diplomaInstitution,
                    diplomaDepartment: c.diplomaDepartment,
                    diplomaDegree: c.diplomaDegree,
                    diplomaPassout: c.diplomaPassout,
                    diplomaPercentage: c.diplomaPercentage,

                    ugInstitution: c.ugInstitution,
                    ugDepartment: c.ugDepartment,
                    ugDepartmentIsOther,
                    ugDegree: c.ugDegree,
                    ugDegreeDropdown: ugDegreeIsOther ? "Other" : c.ugDegree,
                    ugPassout: c.ugPassout,
                    ugPercentage: c.ugPercentage ?? c.cgpa,

                    // PG
                    pgInstitution: c.pgInstitution,
                    pgDepartment: c.pgDepartment,
                    pgDepartmentIsOther,
                    pgDegree: c.pgDegree,
                    pgDegreeIsOther,
                    pgPassout: c.pgPassout,
                    pgPercentage: c.pgPercentage,

                    // 🔹 Experience
                    experience: c.experience,
                    expCompanyName1: c.expCompanyName1,
                    expStartDate1: c.expStartDate1,
                    expEndDate1: c.expEndDate1,
                    expRole1: c.expRole1,
                    expTechnologies1: c.expTechnologies1,
                    expCurrentlyWorking1: c.expCurrentlyWorking1,

                    expCompanyName2: c.expCompanyName2,
                    expStartDate2: c.expStartDate2,
                    expEndDate2: c.expEndDate2,
                    expRole2: c.expRole2,
                    expTechnologies2: c.expTechnologies2,
                    expCurrentlyWorking2: c.expCurrentlyWorking2,

                    expCompanyName3: c.expCompanyName3,
                    expStartDate3: c.expStartDate3,
                    expEndDate3: c.expEndDate3,
                    expRole3: c.expRole3,
                    expTechnologies3: c.expTechnologies3,
                    expCurrentlyWorking3: c.expCurrentlyWorking3,

                    // 🔹 Placement
                    companyName: c.companyName,
                    companyLocation: c.companyLocation,
                    jobRole: c.jobRole,
                    placedBy: c.placedBy,
                    placementDate: c.placementDate,
                    placementRemarks: c.placementRemarks,
                    joiningDate: c.joiningDate,
                    package: c.package,
                    joiningStatus: c.joiningStatus,
                    verificationRemarks: c.verificationRemarks,
                    verificationUpdatedBy: c.verificationUpdatedBy,
                    verificationUpdatedAt: c.verificationUpdatedAt,

                    // Inside mappedData object, add:
                    photoReview: c.photoReview,
                    photoReviewLink: c.photoReviewLink,
                    photoReviewReason: c.photoReviewReason,
                    videoReview: c.videoReview,
                    videoReviewLink: c.videoReviewLink,
                    videoReviewReason: c.videoReviewReason,
                    googleReview: c.googleReview,
                    googleReviewStars: c.googleReviewStars,
                    googleReviewReason: c.googleReviewReason,

                    projects
                };
                console.log(
                    "DB Value:",
                    c.placementStatusChangedBy,
                    c.placementStatusChangedAt
                );

                setFormData(mappedData);
            }

        } catch (error) {
            console.error('Error fetching student record:', error);
            showError('Failed to fetch student record');
        }
    };

    useEffect(() => {

        fetchStudentData();
    }, [id]);
    useEffect(() => {
        if (!formData) return;

        // Prevent duplicate popup on initial render
        if (softPopupShownRef.current) return;

        const warnings = getSoftMandatoryWarnings();
        if (warnings.length > 0) {
            setTimeout(() => {
                showSoftMandatoryPopup(warnings);
            }, 300);
        }

        // mark popup as shown
        softPopupShownRef.current = true;

    }, [formData]);

    const handleDepartmentChange = (selectedDept) => {
        console.log('Department changed to:', selectedDept);
        setFormData(prev => ({
            ...prev,
            department: selectedDept
        }));
    };

    const handleSkillsChange = (selectedSkills) => {
        console.log('Skills changed to:', selectedSkills);
        setFormData(prev => ({
            ...prev,
            skillsKnown: selectedSkills
        }));
    };
    const showSoftMandatoryPopup = (warnings) => {
        const basicKeys = [
            "UG Degree", "PG Degree", "UG Passout", "PG Passout",
            "UG Percentage", "PG Percentage", "PG Department", "UG Department",
            "Experience", "Preferred Job Location", "Gender", "Placement Interest",
            "Diploma Percentage", "Diploma Passout", "Diploma Department", "Resume"
        ];

        const scoreKeys = [
            "Technical Score",
            "Communication Score",
            "Mock Interview",
            "Project 1 Score",
            "Mock Test 1 Score"
        ];

        const basicWarnings = warnings.filter(w => basicKeys.includes(w));
        const scoreWarnings = warnings.filter(w => scoreKeys.includes(w));

        // ⭐ NEW — General warnings like "Please fill qualification"
        const generalWarnings = warnings.filter(
            w => !basicKeys.includes(w) && !scoreKeys.includes(w)
        );

        Swal.fire({
            icon: "warning",
            title: "Important Data Missing!!",
            html: `
        ${generalWarnings.length > 0 ? `
            <p style="
                font-size:18px;
                font-weight:800;
                margin-bottom:20px;
                color:#c70000;
                text-align:center;
            ">${generalWarnings[0]}</p>
        ` : ""}

        ${basicWarnings.length > 0 ? `
            <p style="
                font-size:16px;
                font-weight:700;
                margin-bottom:10px;
                color:#b30000;
            ">Please fill in the below fields to let the student profile match with the job requirements.</p>

            <ul style="text-align:left; padding-left:20px; margin-bottom:20px;">
                ${basicWarnings.map(w => `<li>${w}</li>`).join("")}
            </ul>
        ` : ""}

        ${scoreWarnings.length > 0 ? `
            <p style="
                font-size:16px;
                font-weight:700;
                margin-top:10px;
                margin-bottom:10px;
                color:#b30000;
            ">Assessment is still pending! Until it is completed, the student may not be eligible for placement support. Please ensure this is completed at the earliest.</p>

            <ul style="text-align:left; padding-left:20px;">
                ${scoreWarnings.map(w => `<li>${w}</li>`).join("")}
            </ul>
        ` : ""}
        `,
            confirmButtonText: "Noted"
        });
    };


    const showValidationPopup = (errors) => {
        Swal.fire({
            icon: "error",
            title: "Please Fill These Mandatory Fields",
            html: `
            <ul style="text-align:left; padding-left:20px;">
                ${errors.map(err => `<li>${err}</li>`).join("")}
            </ul>
        `,
            confirmButtonText: "Fix Now"
        });
    };
    const validateAllTabs = () => {
        const errors = [];

        // ================= PERFORMANCE VALIDATION =================
        if (formData.technicalScore > 0 && !formData.technologyRemarks?.trim()) {
            errors.push("Technology Remarks is required when Technology Score is given");
        }
        if (formData.communicationScore > 0 && !formData.communicationRemarks?.trim()) {
            errors.push("Communication Remarks is required when Communication Score is given");
        }
        if (!formData.mockInterview) {
            errors.push("Mock Interview field is required");
        }
        if (formData.mockInterview === "Yes" && !formData.mockRemarks?.trim()) {
            errors.push("Mock Interview Remarks is required when Mock Interview is Yes");
        }

        // ================= PLACEMENT VALIDATION =================
        if (formData.placementStatus === "Placed") {
            if (!formData.companyName?.trim()) errors.push("Company Name is required for placed students");
            if (!formData.companyLocation?.trim()) errors.push("Company Location is required for placed students");
            if (!formData.placementDate) errors.push("Date of Placement is required for placed students");
            if (!formData.jobRole?.trim()) errors.push("Job Role is required for placed students");
            if (!formData.package) errors.push("Package is required for placed students");
            if (!formData.joiningDate) errors.push("Joining Date is required for placed students");
            if (!formData.placedByMode) errors.push("Placed By is required for placed students");
            if (formData.placedByMode === "Others" && !formData.placedBy?.trim()) {
                errors.push("HR/Staff Name is required when 'Others' is selected");
            }
        } else {
            if (formData.placementInterest && formData.placementInterest !== "High" && !formData.staffRemarks?.trim()) {
                errors.push("Additional Notes are required when Placement Interest is not High");
            }
        }

        // ================= PROJECTS VALIDATION =================
        if (!formData.projects || formData.projects.length === 0) {
            errors.push("At least one project is required.");
        } else {
            // ================= PROJECTS VALIDATION =================
            if (formData.projects && formData.projects.length > 0) {
                formData.projects.forEach((proj, idx) => {
                    const pNum = idx + 1;

                    // ✅ Check if user started filling this project
                    const isAnyProjectFieldFilled =
                        proj.projectTitle?.trim() ||
                        proj.projectStatus?.trim() ||
                        proj.projectScore > 0 ||
                        proj.projectFeedback?.trim();

                    // ✅ If user filled ANY field → then validate ALL required fields
                    if (isAnyProjectFieldFilled) {
                        if (!proj.projectTitle?.trim()) {
                            errors.push(`Project ${pNum}: Title is required`);
                        }

                        if (!proj.projectStatus?.trim()) {
                            errors.push(`Project ${pNum}: Status is required`);
                        }

                        if (proj.projectScore > 0 && !proj.projectFeedback?.trim()) {
                            errors.push(`Project ${pNum}: Feedback is required when score is given`);
                        }
                    }
                });
            }

        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.placementStatus === "Placed") {
            const pkg = Number(formData.package || 0);

            if (pkg < 100000) {
                const confirm = await Swal.fire({
                    title: "Annual Package(LPA) is very low!",
                    text: "Mention the salary in LPA. Salary Package is very low and this cannot be considered as Placement",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, continue",
                    cancelButtonText: "Cancel"
                });

                if (!confirm.isConfirmed) {
                    return; // ❌ Stop submit
                }
            }
        }
        setLoading(true);

        const token = localStorage.getItem('token');
        if (!token) {
            showError('Unauthorized! Please log in again.');
            setLoading(false);
            return;
        }

        if (!formData.skillsKnown || formData.skillsKnown.length === 0) {
            showWarning("Please select at least one Skill Known.");
            setLoading(false);
            return;
        }
        if (formData.readyForPlacement === 'Yes' && !formData.resumePath) {
            showWarning("Please upload a resume before updating. Resume is required when student is ready for placement.");
            setLoading(false);
            return;
        }
        // ✅ Validate all tabs before submission
        const validationErrors = validateAllTabs();
        if (validationErrors.length > 0) {
            showValidationPopup(validationErrors);
            setLoading(false);
            return;
        }

        try {
            // ✅ Map projects
            const mappedProjects = {};
            formData.projects.forEach((p, idx) => {
                const i = idx + 1;
                mappedProjects[`projectTitle${i}`] = p.projectTitle || '';
                mappedProjects[`project${i}Status`] = p.projectStatus || '';
                mappedProjects[`project${i}Score`] = p.projectScore ?? 0;
                mappedProjects[`project${i}Feedback`] = p.projectFeedback || '';
            });

            const knownSkill = formData.skillsKnown.join(',');

            const desiredlocation = Array.isArray(formData.location)
                ? formData.location.join(',')
                : formData.location || '';

            const payload = {
                mentor: formData.mentorName,
                mentorId: formData.mentorId,
                email_Id: formData.email,
                placementStatus: formData.placementStatus,
                ProgressStatus: formData.studentProgressStatus,
                placementInterest: formData.placementInterest,
                staffRemarks: formData.staffRemarks,
                desiredlocation,
                ...formData,
                ...mappedProjects,
                knownSkill,
            };

            // ✅ Update main student record
            // ✅ Update main student record
            await axios.put(
                `${process.env.REACT_APP_API_URL}/students-record/${id}`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // ✅ Update registration
            if (formData.studentId && formData.email) {
                const regPayload = {
                    email_Id: formData.email,
                    courseType: formData.courseType,
                    course: formData.courseName,
                };

                await axios.put(
                    `${process.env.REACT_APP_API_URL}/registrations/${formData.studentId}`,
                    regPayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            }

            // 🔥 Refresh latest data from DB
            await fetchStudentData();

            // ✅ Show success
            showSuccess('Student record updated successfully!');

            // ✅ 2️⃣ SHOW WARNING AFTER SUCCESS (DELAYED)
            setTimeout(() => {
                const softWarnings = getSoftMandatoryWarnings();
                if (softWarnings.length > 0) {
                    showSoftMandatoryPopup(softWarnings);
                }
            }, 2000);

        } catch (error) {
            console.error("Error updating record:", error);

            if (error.response?.status === 403) {

                await Swal.fire({
                    icon: "error",
                    title: "Access Denied",
                    html: `
                         Sorry! You are not able to update (Placement Status & Placed By) this record.<br><br>
                         Kindly contact <b>Ms.Dharani (9944474154)</b>.<br><br>
                         Only Super Admin can update.
                       `,
                    confirmButtonText: "OK"
                });

                // Reload original DB values
                await fetchStudentData();

                return;
            }

            showError("Failed to update record");
        } finally {
            setLoading(false);
        }
    };

    if (!formData) return <div>Loading student data...</div>;

    return (
        <div className="edit-student-wrapper" style={{ display: 'flex', gap: '20px' }}>
            {/* Sidebar */}
            <ProfileSidebar
                studentData={formData}
                onStudentDataUpdate={(updatedData) => setFormData(updatedData)}
            />

            {/* Main Form */}
            <div className="edits-form-container" style={{ flex: 1, minHeight: '100%' }}>
                <div className="tab-navigation" style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'studentDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('studentDetails')}
                    >
                        Student Details
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'qualification' ? 'active' : ''}`}
                        onClick={() => setActiveTab('qualification')}
                    >
                        Qualification
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'courseDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('courseDetails')}
                    >
                        Course Details
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'staffDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('staffDetails')}
                    >
                        Staff Details
                    </button>

                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'performance' ? 'active' : ''}`}
                        onClick={() => setActiveTab('performance')}
                    >
                        Performance
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'projects' ? 'active' : ''}`}
                        onClick={() => setActiveTab('projects')}
                    >
                        Projects
                    </button>
                    <button
                        type="button"
                        className={`tabs-button ${activeTab === 'placement' ? 'active' : ''}`}
                        onClick={() => setActiveTab('placement')}
                    >
                        Placement
                    </button>

                </div>

                <form onSubmit={handleSubmit} className="form">
                    <div className="tab-content">
                        {activeTab === 'studentDetails' && (
                            <StudentDetails formData={formData}
                                onFormDataChange={setFormData}
                                onDepartmentChange={handleDepartmentChange}
                                onSkillsChange={handleSkillsChange} />
                        )}
                        {activeTab === 'qualification' && (
                            <Qualification
                                formData={formData}
                                onFormDataChange={setFormData}
                                isEditing={true}  // Set to false if you want view-only mode
                            />
                        )}
                        {activeTab === 'courseDetails' && (
                            <CourseDetails formData={formData} onFormDataChange={setFormData} />
                        )}
                        {activeTab === 'staffDetails' && (
                            <StaffDetails formData={formData} onFormDataChange={setFormData} />
                        )}

                        {activeTab === 'performance' && (
                            <PerformanceSection formData={formData} onFormDataChange={setFormData} />
                        )}
                        {activeTab === 'projects' && (
                            <>
                                {console.log('Projects in formData:', formData.projects)}
                                <ProjectsSection
                                    formData={formData}
                                    onProjectsChange={(projects) =>
                                        setFormData((prev) => ({ ...prev, projects }))
                                    }
                                />
                            </>
                        )}
                        {activeTab === 'placement' && (
                            <PlacementTab
                                formData={formData}
                                onFormDataChange={setFormData}
                                canUpdateVerification={canUpdateVerification}
                            />
                        )}
                    </div>
                    <div className="form-actions" style={{ marginTop: '20px' }}>
                        <button
                            type="button"
                            onClick={() => {
                                navigate('/staff-dashboard');
                            }}
                            className="cancel-btn"
                        >
                            Cancel
                        </button>

                        <button type="submit" disabled={loading} className="submit-btn">
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditStudentRecord;